module.exports = __webpack_public_path__ + "static/media/pic-sl5.237d80e0.png";